import { KYMW2700Model } from '../kymw2700.model';
import { KYMW2700CopyBasePageModel } from '../vo/kymw2700-copy-base-page.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 基版コピー・フェーズ管理画面　基版コピーするサービス
 *
 * @export CopyBasePageService
 * @class CopyBasePageService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class CopyBasePageService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW2700Model}
   * @memberof CopyBasePageService
   */
  private model: KYMW2700Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW2700CopyBasePageModel}
   * @memberof CopyBasePageService
   */
  private vo: KYMW2700CopyBasePageModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof CopyBasePageService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CopyBasePageService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        PageNum: this.vo.pageNum,
        ConfirmFlag: this.vo.confirmFlag
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof CopyBasePageService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW2700Model>model;
    this.vo = <KYMW2700CopyBasePageModel>vo;
    this.successFunc = successFunc;
    this.send('copyBasePage', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CopyBasePageService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

  /**
   * リクエスト失敗時のメソッド。
   * 失敗時の処理を実装する場合、このメソッドをオーバーライドして処理を実装する。
   */
  fault() {
    // 確定ボタンロック解除チェックボックスの状態を確認して制御する
    if (this.model.chkFixationLockEnableMode) {
      this.model.kymw2700Component.updateChkFixationLockMode(true);
    }

    super.fault();

    this.dialogService.openAlertGetMessage('E0249', ['error on position at ' + (this.model.carrot + 1)]);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  exceptionError(status: string, result: any) {
    // 確定ボタンロック解除チェックボックスの状態を確認して制御する
    if (this.model.chkFixationLockEnableMode) {
      this.model.kymw2700Component.updateChkFixationLockMode(true);
    }

    super.exceptionError(status, result);
  }

  /**
   * システムエラー時のメソッド
   * @param data サーバ受信データ
   *  機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public systemErrorHandler(data: any): void {
    // 確定ボタンロック解除チェックボックスの状態を確認して制御する
    if (this.model.chkFixationLockEnableMode) {
      this.model.kymw2700Component.updateChkFixationLockMode(true);
    }

    super.systemErrorHandler(data);
  }

  public plessErrorHandler(errList: any): void {
    // 確定ボタンロック解除チェックボックスの状態を確認して制御する
    if (this.model.chkFixationLockEnableMode) {
      this.model.kymw2700Component.updateChkFixationLockMode(true);
    }

    super.plessErrorHandler(errList);
  }

}
